import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AuthHttpService } from '../../core/services/api/auth-http.service';

@Injectable()
export class ResetPasswordResolver implements Resolve<boolean> {
  constructor(
    private authHttpService: AuthHttpService
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const hash = route.params['hash'];
    return this.authHttpService.checkPasswordRecoveringHash(hash)
      .map(() => true)
      .catch(() => Observable.of(false));
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/auth/reset-password/reset-password.resolver.ts